module.exports = __webpack_public_path__ + "img/makePrivate.49e45a99.svg";